import { cn } from 'cn';
import type React from 'react';
import Icon, { type IconProps, type IconType } from '../../Icon';

interface ButtonContentProps {
  children?: React.ReactNode;
  compact?: boolean | null;
  icon?: IconType;
  iconProps?: Omit<IconProps, 'type'>;
  label?: string;
  rightAligned?: boolean | null;
}

function getIconSpacingClass(
  hasLabel: boolean,
  rightAligned: boolean | null | undefined,
  compact: boolean | null | undefined,
): string {
  if (!hasLabel) return '';

  if (rightAligned) {
    return compact ? 'laane:ml-1 kunde:ml-2' : 'laane:ml-2 kunde:ml-2';
  }

  return compact ? 'laane:mr-1 kunde:mr-2' : 'laane:mr-2 kunde:mr-2';
}

export function ButtonContent({
  children,
  compact,
  icon,
  iconProps,
  label,
  rightAligned,
}: ButtonContentProps) {
  return (
    <>
      {icon ? (
        <Icon
          solidOnActive
          type={icon}
          size={compact ? 'tiny' : 'small'}
          {...iconProps}
          className={cn(
            getIconSpacingClass(
              Boolean(label || children),
              rightAligned,
              compact,
            ),
            iconProps?.className,
          )}
        />
      ) : null}
      {label ?? children}
    </>
  );
}
